export function formatDate(isoString) {
  const date = new Date(isoString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // 0-based month
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
}
export function MappingStatus(status) {
  const statusMap = {
    "new-leads": "New Lead",
    processing: "Processing",
    "in-review": "In Review",
    approved: "Approved",
    rejected: "Rejected",
    submitted: "Submitted",
    closed: "Closed",
  };
  return statusMap[status] || "Unknown Status";
}
export function MappingStyles(status) {
  const statusMap = {
    "new-leads": "text-[#BB8200] bg-[#FFF0CE]",
    processing: "text-[#FFCA20] bg-[#423715]",
    "in-review": "text-[#0000FF] bg-[#CCCCFF]",
    approved: "text-[#00922F] bg-[#D7F8E3]",
    rejected: "text-[#FF0000] bg-[#FFCCCC]",
    submitted: "text-[#FFCA20] bg-[#423715]",
    closed: "text-[#666666] bg-[#F0F0F0]",
    // Task statuses
    PENDING: "text-[#FF0000] bg-[#FFCCCC]",
    IN_PROGRESS: "text-[#FFCA20] bg-[#423715]",
    COMPLETED: "text-[#00922F] bg-[#D7F8E3]",
    CANCELLED: "text-[#666666] bg-[#F0F0F0]",
  };
  return statusMap[status] || "text-black bg-white";
}
export function convertDecimalToTime(decimalHours) {
  const totalMinutes = Math.floor(decimalHours * 60);
  const hours = Math.floor(totalMinutes / 60) || 0;
  const minutes = totalMinutes % 60 || 0;
  return `${hours} hr ${minutes} min`;
}

export const formatElapsed = (seconds) => {
  const hrs = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;
  return `${hrs}h ${mins}m ${secs}s`;
};

export function formatDateDetailed(isoString) {
  if (!isoString) return null;
  const date = new Date(isoString);

  const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const day = days[date.getDay()];
  const dayOfMonth = date.getDate();
  const month = months[date.getMonth()];
  const year = date.getFullYear();

  const getOrdinalSuffix = (n) => {
    if (n > 3 && n < 21) return `${n}th`;
    switch (n % 10) {
      case 1:
        return `${n}st`;
      case 2:
        return `${n}nd`;
      case 3:
        return `${n}rd`;
      default:
        return `${n}th`;
    }
  };

  return `${day}, ${getOrdinalSuffix(dayOfMonth)} ${month}, ${year}`;
}

export function formatTime(isoString) {
  if (!isoString) return null;
  const date = new Date(isoString);

  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";

  hours = hours % 12 || 12; // Convert 0 to 12 for 12 AM
  return `${hours}:${minutes} ${ampm}`;
}

export function formatDurationFromMinutes(totalMinutes) {
  if (
    totalMinutes === null ||
    totalMinutes === undefined ||
    isNaN(totalMinutes) ||
    totalMinutes < 0
  ) {
    return "0 min";
  }
  if (totalMinutes === 0) {
    return "0 min";
  }

  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  return `${hours > 0 ? `${hours} hr ` : ""}${minutes} min`;
}

export const formatReadableDate = (input) => {
  const date = new Date(input);

  if (isNaN(date)) return "Invalid Date";

  return date
    .toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    })
    .replace(/ /g, " ")
    .replace(",", ",");
};
